import { useEffect } from "react";

import { useClubSettings } from "../providers";

export function useHtmlNodeDarkMode({
  supportDarkMode,
}: {
  supportDarkMode: boolean;
}) {
  const {
     webSettings ,
  } = useClubSettings();
  useEffect(() => {
    const htmlNode = document.querySelector("html");
    if (!htmlNode) {
      return;
    }
    if (supportDarkMode) {
      if (webSettings?.darkMode && !htmlNode.classList.contains("dark")) {
        htmlNode.classList.add("dark");
      } else if (
        !webSettings?.darkMode &&
        htmlNode.classList.contains("dark")
      ) {
        htmlNode.classList.remove("dark");
      }
    } else {
      if (htmlNode.classList.contains("dark")) {
        htmlNode.classList.remove("dark");
      }
    }
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [webSettings?.darkMode]);
}
